import { styled } from '@mui/material/styles';
import { SIDEBAR_TRANSITION_MS } from './transition';

export const SidebarRoot = styled('nav')(() => ({
  '--sidebar-transition-duration': `${SIDEBAR_TRANSITION_MS}ms`,

  position: 'fixed',
  top: 0,
  left: 0,
  height: '100vh',
  background: '#FFFFFF',
  lineHeight: 1.3,
  boxShadow: 'none',
  borderRight: '1px solid #e4e7ec',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  transition: `width var(--sidebar-transition-duration) ease`,
  zIndex: 500,
  '&.sidebar--expanded': {
    width: 'var(--sidebar-expanded-width, 260px)',
  },
  '&.sidebar--collapsed': {
    width: 'var(--sidebar-collapsed-width, 76px)',
  },
  '&.sidebar-mobile-drawer': {
    width: 'min(80vw, 320px)',
    transform: 'translateX(-100%)',
    transition: 'transform var(--sidebar-transition-duration) ease',
    boxShadow: '4px 0 24px rgba(0, 0, 0, 0.18)',
    zIndex: 1300,
  },
  '&.sidebar-mobile-drawer.sidebar-mobile-drawer--open': {
    transform: 'translateX(0)',
  },
}));
